import { render, staticRenderFns } from "./LangSwitcher.vue?vue&type=template&id=5dd4b04a&"
import script from "./LangSwitcher.vue?vue&type=script&lang=js&"
export * from "./LangSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports